// $(document).scroll(function() {
//     var scroH = $(document).scrollTop();  //滚动高度
//     var viewH = $(window).height();  //可见高度
//     var contentH = $(document).height();  //内容高度
//     // console.log(scroH)
//     // if(scroH >60){  //距离顶部大于100px时
//     //     $('#j-head_bar').addClass('is_fixed')
//     // }else{
//     //     $('#j-head_bar').removeClass('is_fixed')
//     // }
//     // if (contentH - (scroH + viewH) <= 100){  //距离底部高度小于100px
        
//     // } 
//     // if (contentH = (scroH + viewH)){  //滚动条滑到底部啦
        
//     // } 
//     // console.log(location.hash)
// });
import $ from 'jquery';
import'../page/jquery.cookie.js'
export default {
mounted(){


var _api = '/home-api/api/v1'


// 登录信息
var user_token = $.cookie('company_user_token')

// 设置登录状态
login_status()
function login_status(){
    user_token = $.cookie('company_user_token')
    if(user_token){
        // console.log($.cookie('company_user_phone'))
        $('#j-user-down').show().text($.cookie('company_user_phone'))
        $('#j-login').hide()
    }else{
        $('#j-login').show()
        $('#j-user-down').hide()
    }
}

// 关闭弹窗
$('.d-close').on('click',function(){
    $(this).parents('.dialog-box').fadeOut();
})

// 退出
$('#j-user-down').on('click',function(){
    $('.user-op').slideDown(200);
})
$('#j-loginout').on('click',function(){
    $.cookie('company_user_token', null, { expires: -1, path: '/' })
    $.cookie('company_user_phone', null, { expires: -1, path: '/' })
    login_status()
    toast({ msg: '已退出' })
    setTimeout(function(){
        location.reload()
    }, 1000);
    

})
click_no_this_dom('j-user-down', function(){
    $('.user-op').slideUp(200);
})

// // 登录
// $('.j-btn-login').on('click',function(){
//     $("#form-login")[0].reset();
//     $('.dialog-box').fadeOut();
//     $('#j-login-dialog').fadeIn()
// })

// // 注册
// $('.j-btn-register').on('click',function(){
//     $("#form-register")[0].reset();
//     $('.dialog-box').fadeOut();
//     $('#j-register-dialog').fadeIn()
// })

// // 登录提交
// $('#j-login-sub').on('click',function(){
//     var data = getFormData('#form-login')
//     login_sub(data)
// })

// // 注册提交
// $('#j-register-sub').on('click',function(){
//     var data = getFormData('#form-register')
//     register_sub(data)
// })

// 获取注册验证码
_get_code('#btn-register-code', '#register-phone', '/login/send-msg')

// 查看密码
// $('.j-eye').on('click',function(){
//     var _this = $(this)
//     _this.toggleClass('is_on')
//     _src = _this.prop('src').split('-')
//     if(_this.hasClass('is_on')){
//         _this.prop('src',_src[0]+'-1.png').prev('input').prop('type','text')
//     }else{
//         _this.prop('src',_src[0]+'-0.png').prev('input').prop('type','password')
//     }
// })

// 登录
function login_sub(data){
    if(!data.phone || !data.password){
        
        return
    }
    $.ajax({
        type: "POST",
        url: _api+"/login",
        data: JSON.stringify(data),
        dataType: "json",
        success: function (res) {
            toast({msg: res.msg})
            if(res.status == 200){
                $.cookie('company_user_token', 'Bearer '+res.data.token, { expires: 1, path: '/' })
                $.cookie('company_user_phone', data.phone, { expires: 1, path: '/' })
                
                login_status()

                $('#j-login-dialog').fadeOut()
                setTimeout(() => {
                    location.reload()
                }, 1000);
            }
        }
    });
}

// 注册
function register_sub(data){
    $.ajax({
        type: "POST",
        url: _api+"/login/register",
        data: JSON.stringify(data),
        dataType: "json",
        success: function (res) {
            toast({msg: res.msg})
            if(res.status == 200){
                $('#j-register-dialog').fadeOut()
            }
        }
    });
}

// 咨询
$('#btn-zx').on('click',function(){
    $(this).find('.zx-msg').fadeIn()
})
click_no_this_dom('is-zx', function(){
    $('#btn-zx .zx-msg').fadeOut()
})



// 咨询提交
$('#btn-zx-sub').on('click',function(){
    var data = getFormData('#form-zx')
    if(!check_tel(data.phone)){
        toast({ msg: '请输入正确的电话' })
        return false
    }
    zx_sub(data, function(){
        $('#btn-zx .zx-msg').fadeOut()
    })
})
$('#btn-zx-sub2').on('click',function(){
    var data = getFormData('#form-zx2')
    if(!check_tel(data.phone)){
        if(sessionStorage.getItem('langluageType') == 'en'){
            toast({ msg: 'Please enter phone number' })
        }else{
            toast({ msg: '请输入正确的电话' })
        }
        
        return false
    }
    zx_sub(data)
})

function zx_sub(data, callback){
    // if (!user_token) {
    //     toast({ msg: '请先登录' })
    //     $('#j-login-dialog').fadeIn()
    //     return
    // }
    $.ajax({
        type: "POST",
        url: _api+"/service_contact/submit",
        // headers: {Authorization: user_token},
        data: JSON.stringify(data),
        dataType: "json",
        success: function (res) {
            toast({msg: res.msg})
            // if(res.status == 200){             
                callback&&callback()
            // }
        },error: function (xhr,status,error) {
            // if(xhr.responseJSON == 500){
                toast({msg: xhr.responseJSON.msg})
            // }
        }
    });
}

// 点击 非classname区域
function click_no_this_dom(classname, callback){
    $(document).bind('click',function(e){
        var e = e || window.event; //浏览器兼容性
        var elem = e.target || e.srcElement;
        while (elem) { //循环判断至跟节点，防止点击的是div子元素
            if ($(elem).hasClass(classname)) {
                return;
            }
            elem = elem.parentNode;
        }
        callback&&callback()
    });
}

// 获取form表单数据
function getFormData(formId){
    var data = {};
    var results = $(formId).serializeArray();
    $.each(results,function(index,item){
        //文本表单的值不为空才处理
        if(item.value && $.trim(item.value)!=""){
            if(!data[item.name]){
                data[item.name]=item.value;
            }else{
                //name属性相同的表单，值以英文,拼接
                data[item.name]=data[item.name]+','+item.value;
            }
        }
    });
    //console.log(data);
    return data;
}

// 提示信息
function toast(n) {
    var t = document;
    var toastId = document.getElementById('toastId');
    if(toastId){
        toastId.remove();
        // toastId.parentNode.removeChild(toastId);
    }
    
    var e = t.createElement("div")
    e.id = 'toastId';
    e.innerHTML = n.msg 
    
    t.body.appendChild(e);
    var r = setTimeout(function() {
        clearTimeout(r)
        e.remove();
        // t.body.removeChild(e)
    }, n.time || 2e3)
    
}


function _get_code(btn, phone, rul){
    var _time = 60;
    $(btn).on('click',function(){
        // var _this = $(this)
        if($(this).hasClass('is-off')){

        }else{
            var _phone = $(phone).val()
            
            if(_phone){
                if(!check_phone(_phone)){
                    toast({ msg: '请输入正确的手机号' })
                }else{
                    _time = 60
                    set_time()
                    get_code(_phone)
                }
            }
        }
    })
    function set_time(){
        if( _time<= 0){
            $(btn).removeClass('is-off').html('获取验证码')
        }else{
            $(btn).addClass('is-off').html('('+_time+')')
            setTimeout(function() {
                _time--
                set_time()
            }, 1000)
        }
    }
    function get_code(phone){
        $.ajax({
            type: "POST",
            url: _api+rul,
            data: JSON.stringify({
                phone: phone
            }),
            headers: {Authorization: user_token|| ''},
            dataType: "json",
            success: function (res) {
                if(res.status == 200){
                    toast({msg: res.data.msg})
                }else{
                    _time = 0
                    toast({msg: res.msg})
                }
            }
        });
    }
}

// 多选
$('.s-checkbox').on('click',function(){
    $(this).toggleClass('checked')
})

// 手机
function check_phone(phone){
    // return phone.match(/^1[3-9]\d{9}$/)
    var re = new RegExp(/^1[3-9]\d{9}$/)
    // console.log(tel, re.test(tel))
    return re.test(phone)
}
// 手机 或 电话
function check_tel(tel){
    var re = new RegExp(/^(\d{3,4}-)?\d{7,8}$|^1[3-9]\d{9}$/)
    // console.log(tel, re.test(tel))
    return re.test(tel)
}
// 邮箱
function check_email(email){
    var re = new RegExp(/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/)
    return re.test(email)
}

// 截取路径的参数
// getUrlParamValue =  (name) =>{
//     var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
// 	var r = window.location.search.substr(1).match(reg);  //匹配目标参数
// 	if (r != null) return unescape(r[2]); return null; //返回参数值
// };


function formatDate (value) {
    let date = new Date(value);
    if(date == 'Invalid Date'){
        return ''
    }
    let y = date.getFullYear();
    let MM = date.getMonth() + 1;
    MM = MM < 10 ? ('0' + MM) : MM;
    let d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    let h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    let m = date.getMinutes();
    m = m < 10 ? ('0' + m) : m;
    let s = date.getSeconds();
    s = s < 10 ? ('0' + s) : s;
    return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
}
}
}


// WEBPACK FOOTER //
// ./src/js/common.js